import { cn } from '@lib/utils';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import type { ReactNode } from 'react';


export interface TooltipProps {
  content: ReactNode;
  children: ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
  delayDuration?: number;
  maxWidthClass?: string;
}

export function Tooltip({
  content,
  children,
  side = 'top',
  align = 'center',
  delayDuration = 250,
  maxWidthClass = 'max-w-[200px]',
}: TooltipProps): JSX.Element {
  return (
    <RadixTooltip.Provider delayDuration={delayDuration} skipDelayDuration={120}>
      <RadixTooltip.Root>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content
            side={side}
            align={align}
            sideOffset={6}
            className={cn(
              'z-[200] rounded-lg bg-[#1D1D1F]/92 px-3 py-1.5 text-[12px] font-medium text-white backdrop-blur-sm',
              'data-[state=delayed-open]:animate-fade-in data-[state=closed]:animate-fade-in',
              maxWidthClass,
            )}
          >
            {content}
            <RadixTooltip.Arrow
              className="fill-[#1D1D1F]/92"
              width={10}
              height={5}
            />
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
}
